import { loadScript } from '../util/load-script';

import { Provider } from './providers.types';

const INSTAGRAM_EMBED_SDK_URL = 'https://www.instagram.com/embed.js';
const INSTAGRAM_EMBED_SDK_VERSION = 'v12.0';
const INSTAGRAM_LOADING_TIMEOUT_MS = 15000;

const FIX_HEIGHT_INTERVAL_MS = 500;
const FIX_HEIGHT_TIMEOUT_MS = 5000;

export default function Facebook(): Provider {
  async function mount(element, url) {
    element.classList.remove('social-embed--rendered');

    element.innerHTML = `
      <blockquote class="instagram-media"
        data-instgrm-captioned
        data-instgrm-permalink="${url}"
        data-instgrm-version="${INSTAGRAM_EMBED_SDK_VERSION}"
        width="100%">
      </blockquote>
    `;

    try {
      const sdk = await loadSdk();
      sdk.Embeds.process();

      fixSafariIFrameHeight();
    } catch (error) {
      console.warn(error);
    }
  }

  return {
    mount
  };
}

async function loadSdk(): Promise<any> {
  if (typeof window['instgrm']?.Embeds === 'object') {
    return window['instgrm'];
  }

  await loadScript(INSTAGRAM_EMBED_SDK_URL);

  return new Promise((resolve) => {
    const intervalPointer = setInterval(() => {
      if (typeof window['instgrm']?.Embeds !== 'object') {
        return;
      }

      clearInterval(intervalPointer);
      clearTimeout(lifelinePointer);
      resolve(window['instgrm']);
    }, 50);

    // Lifeline timeout. Will be called after 15 seconds
    // to prevent interval above from running indefinitely.
    const lifelinePointer = setTimeout(() => {
      clearInterval(intervalPointer);
    }, INSTAGRAM_LOADING_TIMEOUT_MS);
  });
}

/**
 * On safari, the iframe has a wrong height on the initial load. Resetting the height ONCE resolves this bug, as
 * Instagram then set's the correct height. FCBO-1726
 */
function fixSafariIFrameHeight() {
  if (!(/apple/i.test(navigator.vendor))) {
    return;
  }

  const fixHeight = () => {
    document.querySelectorAll('[id^=\'instagram-embed-\']').forEach(element => {
      const iFrame = element as HTMLIFrameElement;
      if (iFrame.height && parseInt(iFrame.height) < 50) {
        iFrame.height = undefined;
      }
    });
  };

  // run immediately if the iframe has already loaded
  fixHeight();

  // if page load is slow also check a few times afterwards
  const fixHeightInterval = setInterval(fixHeight, FIX_HEIGHT_INTERVAL_MS);

  setTimeout(() => {
    clearInterval(fixHeightInterval);
  }, FIX_HEIGHT_TIMEOUT_MS);
}
